export const CREDITS_BREAKDOWN_LABELS: Record<string, string> = {
  company: "Company",
  spend: "Spend",
  spend_smb: "Spend SMB",
  relative_spend: "Relative Spend",
  relative_spend_smb: "Relative Spend SMB",
  contract: "Contract",
  intent: "Intent",
  installs: "Installs",
  fai: "FAI",
  ai_spend: "AI Spend",
  ai_spend_smb: "AI Spend SMB",
  ai_spend_relative: "AI Relative Spend",
  buyer_intent: "Buyer Intent",
  row_based_spend: "Row-Based Spend",
  row_based_spend_smb: "Row-Based Spend SMB",
  financing_events: "Financing Events",
};
